import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		marginRight: 20,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function DateIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 6C4.34315 6 3 7.34315 3 9V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V9C21 7.34315 19.6569 6 18 6H6Z" stroke={props.fill} strokeWidth="2" />
			<rect x="7.5" y="3.5" width="1" height="5" rx="0.5" fill="#3D4047" stroke={props.fill} />
			<rect x="15.5" y="3.5" width="1" height="5" rx="0.5" fill="#3D4047" stroke={props.fill} />
			<rect opacity="0.5" x="15.5" y="15.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
			<rect opacity="0.5" x="11.5" y="15.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
			<rect opacity="0.5" x="7.5" y="15.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
			<rect opacity="0.5" x="15.5" y="11.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
			<rect opacity="0.5" x="11.5" y="11.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
			<rect opacity="0.5" x="7.5" y="11.5" width="1" height="1" rx="0.5" fill={props.fill} stroke={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<DateIcon fill={props.fill} />
		</div>
	);
}